import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
};

const slice = createSlice({
  name: "settingGeneral",
  initialState,
  reducers: {
    resetState: () => initialState,
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { resetState, setData } = slice.actions;

export default slice.reducer;
